import React from "react"
import { View } from "react-native"
import { cn } from "./util/cn"

export interface ProgressSegment {
  value: number
  color: string
  label?: string
}

interface BFMultiProgressBarProps {
  segments: ProgressSegment[]
  height?: number
  gap?: number
  borderRadius?: number
  emptyColor?: string
  className?: string
}

export const BFMultiProgressBar: React.FC<BFMultiProgressBarProps> = ({
  segments,
  height = 16,
  gap = 4,
  borderRadius = 4,
  emptyColor,
  className,
}) => {
  const filteredSegments = segments.filter((segment) => segment.value > 0)

  const totalValue = filteredSegments.reduce(
    (acc, segment) => acc + segment.value,
    0
  )

  const normalizedSegments =
    totalValue > 1
      ? filteredSegments.map((segment) => ({
          ...segment,
          value: segment.value / totalValue,
        }))
      : filteredSegments

  const displaySegments = [...normalizedSegments]
  if (totalValue < 1.0) {
    displaySegments.push({
      value: 1.0 - totalValue,
      color: emptyColor || "transparent",
    })
  }

  return (
    <View className={cn("", className)}>
      <View className="flex-row" style={{ height, gap }}>
        {displaySegments.map((segment, index) => {
          const isCustomColor = segment.color.startsWith("#")
          const widthPercent = Math.max(0, Math.min(100, segment.value * 100))

          return (
            <View
              key={index}
              style={[
                { flex: widthPercent, borderRadius },
                isCustomColor ? { backgroundColor: segment.color } : null,
              ]}
              className={
                // eslint-disable-next-line tailwindcss/no-custom-classname
                cn("h-full", !isCustomColor ? `bg-${segment.color}` : "")
              }
            />
          )
        })}
      </View>
    </View>
  )
}
